import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
var _dec, _dec2, _dec3, _dec4, _obj;
import Controller from "@ember/controller";
import EmberObject from "@ember/object";
import { empty, or } from "@ember/object/computed";
import { propertyEqual } from "discourse/lib/computed";
import { emailValid } from "discourse/lib/utilities";
import discourseComputed from "discourse-common/utils/decorators";
import I18n from "discourse-i18n";
export default Controller.extend((_dec = discourseComputed("newEmail"), _dec2 = discourseComputed("saving", "new"), _dec3 = discourseComputed("newEmail"), _dec4 = discourseComputed("invalidEmail", "oldEmail", "newEmail"), (_obj = {
  queryParams: ["new"],
  taken: false,
  saving: false,
  error: false,
  success: false,
  oldEmail: null,
  newEmail: null,
  successMessage: null,
  newEmailEmpty: empty("newEmail"),
  saveDisabled: or("saving", "newEmailEmpty", "taken", "unchanged", "invalidEmail"),
  unchanged: propertyEqual("newEmailLower", "oldEmail"),
  newEmailLower(newEmail) {
    return newEmail.toLowerCase().trim();
  },
  saveButtonText(saving, isNew) {
    if (saving) {
      return I18n.t("saving");
    }
    if (isNew) {
      return I18n.t("user.add_email.add");
    }
    return I18n.t("user.change");
  },
  invalidEmail(newEmail) {
    return !emailValid(newEmail);
  },
  emailValidation(invalidEmail, oldEmail, newEmail) {
    if (invalidEmail && (oldEmail || newEmail)) {
      return EmberObject.create({
        failed: true,
        reason: I18n.t("user.email.invalid")
      });
    }
  },
  reset() {
    this.setProperties({
      taken: false,
      saving: false,
      error: false,
      success: false,
      newEmail: null
    });
  },
  actions: {
    saveEmail() {
      this.set("saving", true);
      return (this.new ? this.model.addEmail(this.newEmail) : this.model.changeEmail(this.newEmail)).then(() => {
        this.set("success", true);
        if (this.model.staff) {
          this.set("successMessage", I18n.t("user.change_email.success_staff"));
        } else {
          if (this.currentUser.admin) {
            this.set("successMessage", I18n.t("user.change_email.success_via_admin"));
          } else {
            this.set("successMessage", I18n.t("user.change_email.success"));
          }
        }
      }, e => {
        this.setProperties({
          error: true,
          saving: false
        });
        if (e.jqXHR.responseJSON && e.jqXHR.responseJSON.errors && e.jqXHR.responseJSON.errors[0]) {
          this.set("errorMessage", e.jqXHR.responseJSON.errors[0]);
        } else {
          this.set("errorMessage", I18n.t("user.change_email.error"));
        }
      });
    }
  }
}, (_applyDecoratedDescriptor(_obj, "newEmailLower", [_dec], Object.getOwnPropertyDescriptor(_obj, "newEmailLower"), _obj), _applyDecoratedDescriptor(_obj, "saveButtonText", [_dec2], Object.getOwnPropertyDescriptor(_obj, "saveButtonText"), _obj), _applyDecoratedDescriptor(_obj, "invalidEmail", [_dec3], Object.getOwnPropertyDescriptor(_obj, "invalidEmail"), _obj), _applyDecoratedDescriptor(_obj, "emailValidation", [_dec4], Object.getOwnPropertyDescriptor(_obj, "emailValidation"), _obj)), _obj)));